var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "telephoneInputComponent",
      staticClass: "telephone-input-component",
    },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c(
          "div",
          {
            class: [
              "flex-grow",
              { "border-error error-anchor": _vm.phoneError },
            ],
            staticStyle: { "border-radius": "3px" },
          },
          [
            _c(
              "vue-tel-input",
              {
                ref: "vueTelInputComponents",
                attrs: {
                  mode: _vm.mode,
                  validCharactersOnly: true,
                  inputOptions: _vm.inputOptions,
                  dropdownOptions: _vm.dropdownOptions,
                  defaultCountry: _vm.defaultCountryInternal,
                  styleClasses: "pl-0",
                  onlyCountries: _vm.allowedCountries,
                },
                on: {
                  input: _vm.onInput,
                  validate: _vm.onValidate,
                  "country-changed": _vm.countryChanged,
                  blur: _vm.onBlur,
                },
                model: {
                  value: _vm.phone,
                  callback: function ($$v) {
                    _vm.phone = $$v
                  },
                  expression: "phone",
                },
              },
              [
                _c("template", { slot: "arrow-icon" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.allowedCountries.length > 1,
                          expression: "allowedCountries.length > 1",
                        },
                      ],
                      staticClass: "vti__dropdown-arrow",
                    },
                    [_vm._v("▼")]
                  ),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.parsedPhoneDetails.national,
                  expression: "parsedPhoneDetails.national",
                },
              ],
              attrs: { type: "hidden", name: "telephone_national" },
              domProps: { value: _vm.parsedPhoneDetails.national },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.parsedPhoneDetails,
                    "national",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.parsedPhoneDetails.international,
                  expression: "parsedPhoneDetails.international",
                },
              ],
              attrs: { type: "hidden", name: "telephone_international" },
              domProps: { value: _vm.parsedPhoneDetails.international },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.parsedPhoneDetails,
                    "international",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.parsedPhoneDetails.international_prefix,
                  expression: "parsedPhoneDetails.international_prefix",
                },
              ],
              attrs: { type: "hidden", name: "telephone_international_prefix" },
              domProps: { value: _vm.parsedPhoneDetails.international_prefix },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.parsedPhoneDetails,
                    "international_prefix",
                    $event.target.value
                  )
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.showClearButton
          ? _c(
              "button",
              {
                staticClass: "border-0 p-0 bg-transparent ml-3",
                attrs: { type: "button" },
                on: { click: _vm.handleDeleteNumber },
              },
              [_c("svg-close-circle")],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.phoneError
        ? _c("div", { staticClass: "invalid-feedback d-block" }, [
            _vm._v("\n        " + _vm._s(_vm.phoneError) + "\n    "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }